import { Fragment } from "react";
import { Col } from "reactstrap";
import { dynamicImage, Image } from "../../../../Utils";
import SvgIcon from "../../../CommonComponents/SvgIcon";
import { ChatWidthAnimationTitle, MainChatTitle } from "../../../../Constants/Constants";

const MainChat = () => {
  return (
    <Fragment>
      <Col xxl="4" lg="6" sm="12">
        <div className="element-card">
          <div className="element-card-header heading"><h2>{MainChatTitle}</h2></div>
          <div className="element-card-body">
            <ul className="chat-main">
              <li>
                <div className="chat-box">
                  <div className="profile online">
                    <Image className="bg-img img-fluid" src={dynamicImage("avtar/1.jpg")} alt="Avatar" />
                  </div>
                  <div className="details">
                    <h4>{"Josephin water"}</h4>
                    <h5><SvgIcon className="fill-primary" iconId="right-2" />{"Hi, i am josephin. How are you.. ! There are many variations of passages."}</h5>
                  </div>
                  <div className="date-status"><h6>22/10/24</h6></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Col>
      <Col xxl="12" lg="6" className="p-0">
        <div className="massage_box">
          <div className="element-card">
            <div className="element-card-header heading"><h2>{ChatWidthAnimationTitle}</h2></div>
            <div className="element-card-body">
              <ul className="chat-main">
                <li>
                  <div className="chat-box">
                    <div className="profile online">
                      <Image className="bg-img img-fluid" src={dynamicImage("avtar/1.jpg")} alt="Avatar" />
                    </div>
                    <div className="details">
                      <h4>{"Josephin water"}</h4>
                      <h5>{"Hi, i am josephin. How are you.. ! There are many variations of passages."}</h5>
                    </div>
                    <div className="date-status"><h6>22/10/24</h6><span><Image className="img-30" src={dynamicImage("gif/Loader.gif")} alt="gif" /></span></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default MainChat;
